import { createRoute, Link } from '@tanstack/react-router'
import { rootRoute } from './__root'
import { PinIcon, UsersIcon, SmartphoneIcon } from '../components/Icons'

export const aboutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/about',
  component: AboutComponent,
})

function AboutComponent() {
  return (
    <div className="page about-page">
      <div className="container">
        <header className="page-header">
          <span className="eyebrow">about</span>
          <h1 className="page-title">A small studio with a big table.</h1>
          <p className="page-subtitle">
            Cloudymedia is an independent game studio based in Buenos Aires,
            Argentina.
          </p>
        </header>
      </div>

      <section className="section">
        <div className="container split">
          <div className="prose">
            <p>
              We started Cloudymedia to build the games we wanted to play with
              our own friends. That led to <strong>Gran Truco Argentino</strong>,
              a faithful digital version of the country's favourite card game,
              now played by more than two million people on iOS, Android and
              the web.
            </p>
            <p>
              We design, engineer and operate everything in-house. Being a
              small team means we ship fast, listen closely to our community
              and take care of the details that make a game feel right.
            </p>
            <p>
              <Link to="/contact" className="mono" style={{ color: 'var(--accent)' }}>
                → get in touch
              </Link>
            </p>
          </div>

          <div className="spec-list" aria-label="Studio facts">
            <div className="spec-row">
              <span className="spec-key">studio</span>
              <span className="spec-val">Cloudymedia</span>
            </div>
            <div className="spec-row">
              <span className="spec-key">location</span>
              <span className="spec-val">Buenos Aires, AR</span>
            </div>
            <div className="spec-row">
              <span className="spec-key">focus</span>
              <span className="spec-val">Mobile · Web · Social games</span>
            </div>
            <div className="spec-row">
              <span className="spec-key">flagship</span>
              <span className="spec-val">Gran Truco Argentino</span>
            </div>
            <div className="spec-row">
              <span className="spec-key">players</span>
              <span className="spec-val accent">2M+</span>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-head">
            <span className="eyebrow">what we value</span>
            <h2 className="section-title">Principles we build by.</h2>
          </div>

          <div className="card-grid">
            <article className="card">
              <div className="card-icon">
                <PinIcon />
              </div>
              <span className="card-index">01</span>
              <h3 className="card-title">Made in Argentina</h3>
              <p className="card-text">
                Our games are rooted in local culture and built with the
                authenticity only people who grew up playing them can bring.
              </p>
            </article>

            <article className="card">
              <div className="card-icon">
                <SmartphoneIcon />
              </div>
              <span className="card-index">02</span>
              <h3 className="card-title">Fun first</h3>
              <p className="card-text">
                Every technical decision serves the play experience. Fast
                matches, fair rules, and no friction between you and the game.
              </p>
            </article>

            <article className="card">
              <div className="card-icon">
                <UsersIcon />
              </div>
              <span className="card-index">03</span>
              <h3 className="card-title">Community driven</h3>
              <p className="card-text">
                Our roadmap is shaped by the people who play every day. We read
                the reviews, answer the emails and ship what matters.
              </p>
            </article>
          </div>
        </div>
      </section>
    </div>
  )
}
